/**
 * Returns the gender pronoun translation key ("her" or "his") for a given gender code.
 * @param {string} genderCode - The gender code (e.g., "F", "G", "M", etc.)
 * @param {function} t - The translation function.
 * @returns {string} The translated gender pronoun.
 */
export function getGenderMessage(genderCode, t) {
  if (!genderCode) return "";
  if (genderCode === "F" || genderCode === "G") {
    return t("her");
  }
  return t("his");
}
